import { Link } from 'react-router-dom'
import { DataTable, type DataTableColumn } from '@/components/DataTable'
import { RowActions } from '@/components/RowActions'
import type { DocumentTypeEntry } from '@/types/bundle'
import { documentTypeLabel } from '../labels'

export interface DocumentTypeRow {
  id: string
  entry: DocumentTypeEntry
}

export interface DocumentTypesTableProps {
  rows: DocumentTypeRow[]
  onDuplicate: (row: DocumentTypeRow) => void
  onDelete: (row: DocumentTypeRow) => void
}

export function DocumentTypesTable({ rows, onDuplicate, onDelete }: DocumentTypesTableProps) {
  const columns: DataTableColumn<DocumentTypeRow>[] = [
    {
      key: 'name',
      header: 'Name',
      render: (row) => (
        <Link to={`/document-types/${row.id}`} className="text-accent hover:underline">
          {documentTypeLabel(row.id)}
        </Link>
      ),
    },
    {
      key: 'groups',
      header: 'Required-keyword groups',
      align: 'right',
      render: (row) => row.entry.identification.required_keywords_any_of.length,
    },
    {
      key: 'fields',
      header: 'Fields',
      align: 'right',
      render: (row) => Object.keys(row.entry.fields).length,
    },
    {
      key: 'actions',
      header: '',
      align: 'right',
      render: (row) => <RowActions onDuplicate={() => onDuplicate(row)} onDelete={() => onDelete(row)} />,
    },
  ]

  return <DataTable columns={columns} data={rows} getRowKey={(row) => row.id} />
}
